export default __webpack_public_path__ + "static/media/rt-mesh-icon.4f3e77fe.png";